import { AxiosError } from 'axios'

/**
 * The `ApiError` class is a custom error class that extends the built-in `Error`
 * class and includes additional properties for handling API errors.
 */
export class ApiError extends Error {
  status: number
  errorMessage: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response?: any
  responseData: object | SystemError | undefined

  constructor(err: AxiosError, respData?: object | SystemError) {
    super(err.message)
    this.status = err.response?.status ?? 0
    this.errorMessage = err.message
    this.responseData = respData
    this.response = err.response?.data
  }
}

export interface AttachmentError {
  idml: string
  message: string
  fileName: string
  fieldName: string
}

// only if response code was 500 OR 404
interface SystemError {
  data?: object
  entityName?: string
  helpLink?: string
  hResult?: number
  innerException?: string
  message?: string
  refId?: string
  singleton?: boolean
  source?: string
  stackTrace?: string
}
// NetworkError eg: not connection ?
// {
//   "refId": "bbe76b02-9fd0-46e9-9dc5-c04f887a82eb",
//   "entityName": "TEST_ENTITY",
//   "singleton": false,
//   "message": "Exception of type 'FME.mSDK.ObjectModel.Exceptions.EntityNotFoundException' was thrown.",
//   "data": {},
//   "innerException": null,
//   "helpLink": null,
//   "source": "FME.mSDK.DataAccess",
//   "hResult": -2146233088,
//   "stackTrace": "   at FME.mSDK.DataAccess.DataProviders.RelationalDB.RelationalDBEntityDataAccess.LoadEntityAsync(Guid id, String entityName, LoadEntityOptions options, String formName) in /home/pobo/workspace/ensemble/mSDK/tms-shr-msdk/src/DataAccess/DataProviders/RelationalDB/RelationalDBEntityDataAccess.cs:line 364\n   at FME.mSDK.DataAccess.DataProviders.RelationalDB.RelationalDBDataProvider.LoadEntityAsync(Guid id, String entityName, String formName, Boolean skipCanUpdate) in /home/pobo/workspace/ensemble/mSDK/tms-shr-msdk/src/DataAccess/DataProviders/RelationalDB/RelationalDBDataProvider.cs:line 131\n   at FME.mSDK.DataAccess.DataManagers.DataManager.LoadEntityAsync(String entityName, Guid id, String formName, Boolean skipCanUpdate) in /home/pobo/workspace/ensemble/mSDK/tms-shr-msdk/src/DataAccess/DataManagers/DataManagerLoad.cs:line 53\n   at mSDK.Infrastructure.Controllers.EntityController.Get(String entityName, Guid id, String formName, Boolean includeAcl) in /home/pobo/workspace/ensemble/mSDK/tms-shr-msdk/src/UI/Controllers/EntityController.cs:line 211"
// }

//

//check error codes
// export function parseHttpResponseCodes(e: ApiError) {}
// HttpStatusCode
